import Prism from "prismjs"

type GlobalWithPrism = typeof globalThis & {
  Prism: typeof Prism
}

let prismJsonReady: Promise<typeof Prism> | null = null

export const ensurePrismJson = (): Promise<typeof Prism> => {
  if (prismJsonReady !== null) {
    return prismJsonReady
  }

  prismJsonReady = (async () => {
    Prism.manual = true
    ;(globalThis as GlobalWithPrism).Prism = Prism
    await import("prismjs/components/prism-json")
    return Prism
  })()

  return prismJsonReady
}
